export default "__VITE_ASSET__D8Hj0KMq__"